module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "miq-for-teams-city@2x.8e1d1a59.png" + "?" + Date.now();